/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */
export var questionType = {
  '-3': {
    label: '定位题',
    value: -3
  },
  '-2': {
    label: '时间题',
    value: -2,
    children: {
      1: {
        label: '时间段题',
        value: -2,
        secondType: 1
      },
      2: {
        label: '时刻题',
        value: -2,
        secondType: 2
      }
    }
  },
  '-1': {
    label: '目标题',
    value: -1
  },
  1: {
    label: '单选题',
    value: 1
  },
  2: {
    label: '多选题',
    value: 2
  },
  3: {
    label: '单选投票题',
    value: 3
  },
  4: {
    label: '单项填空题',
    value: 4
  },
  5: {
    label: '多项填空题',
    value: 5
  },
  6: {
    label: '打分题',
    value: 6
  },
  7: {
    label: '地址',
    value: 7
  },
  8: {
    label: '上传附件',
    value: 8
  },
  9: {
    label: '上传pdf',
    value: 9
  },
  10: {
    label: '上传word',
    value: 10
  },
  11: {
    label: '上传excel',
    value: 11
  },
  12: {
    label: '上传ppt',
    value: 12
  },
  13: {
    label: '上传图片',
    value: 13
  },
  14: {
    label: '时间题',
    value: 14
  },
  15: {
    label: '月度题',
    value: 15
  },
  16: {
    label: '定位题',
    value: 16
  },
  17: {
    label: '描述题',
    value: 17
  },
  18: {
    label: '描述题',
    value: 18
  },
  19: {
    label: '数字填空题',
    value: 19
  },
  20: {
    label: '签名题',
    value: 20
  }
};